<template>
    <div id="map" ref="map"></div>
</template>

<script>
export default {
    props: ['lat', 'lng'],
    data: function() {
        return {
            interval: null
        }
    },
    mounted: function() {
        if (!(this.lat && this.lng)) {
            return;
        }
        
        this.interval = setInterval(_ => {
            if (window.google) {
                this.init();
            }
        }, 500);
    },
    methods: {
        init: function() {
            clearInterval(this.interval);

            const position = { lat: this.lat, lng: this.lng };
            
            const map = new google.maps.Map(this.$refs.map, {
                zoom: 15,
                center: position,
            });
            
            const marker = new google.maps.Marker({
                position: position,
                map: map,
            });
        }
    }
}
</script>
<style scoped>
#map {
    height: 300px;
    width: 100%;
}
</style>